"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToCartCommand = void 0;
class AddToCartCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { value, contents, currency } = this.input;
        const { gtag: googleAnalyst } = config;
        googleAnalyst('event', 'add_to_cart', {
            currency: currency,
            value: value,
            items: contents?.map(content => ({
                item_id: content.id,
                quantity: content.quantity,
                google_business_vertical: 'retail'
            })) ?? []
        });
        return Promise.resolve();
    }
}
exports.AddToCartCommand = AddToCartCommand;
